import React from 'react';

import './style.less';

function widget_user_agreement() {
  return (
    <div className='tfs_user-agreement'>
      <h1>GEBRUIKSOVEREENKOMST</h1>
      <div className="tfs_user-agreement-body">
        <h1><b>Algemene voorwaarden</b></h1>
        <h2><b>1. Handelsvoorwaarden</b></h2>
        <ul>
          <li>
            De volgende handelsvoorwaarden zijn van toepassing op alle activiteiten
            tussen jou en The Fashion Society NV (hierna “THE FASHION STORE”, “THE
            FASHION STORE e-shop”, “de e-shop” of “we/wij”). Door het plaatsen van een
            bestelling ga je uitdrukkelijk akkoord met de algemene voorwaarden.
          </li>
          <li>
            THE FASHION STORE doet zijn uiterste best om de algemene voorwaarden
            duidelijk en in bevattelijke bewoordingen te omschrijven. Gelieve de
            algemene voorwaarden zorgvuldig door te nemen alvorens je een bestelling
            plaatst.
          </li>
          <li>
            THE FASHION STORE behoudt zich het recht voor de algemene voorwaarden op
            ieder moment en zonder voorafgaande berichtgeving te wijzigen. Deze
            wijziging geldt enkel voor de toekomst en heeft geen invloed op reeds
            geplaatste bestellingen. Wij raden je aan de algemene voorwaarden
            regelmatig te consulteren zodat je op de hoogte blijft van de
            toepasselijke bepalingen.
          </li>
        </ul>
        <h3><b>1.1 Bedrijfsgegevens</b></h3>
        <ul>
          <li>The Fashion Society NV (THE FASHION STORE</li>
          <li>Brusselsesteenweg 185 1785 Merchtem (België)</li>
          <li><b>Btw-nummer/Ondernemingsnummer</b> : BE 0553 548 910</li>
          <li><b>Oprichtingsdatum</b> : 20/10/1992</li>
          <li><b>Vertegenwoordigd door</b>: Luc Van Mol</li>
          <li><b>Operationeel verantwoordelijke e-shop</b>: Femke MUSSELS.</li>
          <li><b>Telefoon</b>: 02/568.11.85</li>
          <li><b>E-mail</b>: info@thefashionstore.be.</li>
          <li>
            <b>Rekeningnummer</b>: BE77 3630 8928 8742 (belangrijk: vermeld steeds de
            unieke niet-gestructureerde mededeling uit je orderbevestiging).
          </li>
        </ul>
        <h3><b>1.2 Nauwkeurigheid van gegevens</b></h3>
        <p>
          We doen er alles aan om er voor te zorgen dat de informatie op deze website
          op ieder moment volledig, nauwkeurig en actueel is. Ondanks deze
          inspanningen is het mogelijk dat de informatie op onjuist, onvolledig of
          verouderd is. THE FASHION STORE kan geen garantie bieden wat betreft
          volledigheid, nauwkeurigheid of actualiteit van enige informatie op deze
          website.
        </p>
        <h3><b>1.3 Prijzen</b></h3>
        <p>
          Alle prijzen op de THE FASHION STORE e-shop zijn weergegeven in euro. Alle
          prijzen zijn inclusief 21% btw, exclusief verzendingskosten. Indien er
          verzendkosten zijn, melden we dit altijd voordat je je aankoop definitief
          plaatst.
        </p>
        <h3><b>1.4 Garantie</b></h3>
        <p>
          Wij garanderen dat onze goederen conform zijn aan uw bestelling en voldoen
          aan de normale verwachtingen die u ervan mag hebben rekening houdende met de
          specificaties van het product. Wij garanderen u natuurlijk ook dat onze
          goederen voldoen aan alle op het ogenblik van uw bestelling bestaande
          wetten. Bovendien hanteren wij wat betreft het leveren van goederen de
          wettelijke minimumgarantietermijn van twee jaar indien het goed niet conform
          is aan de geplaatste bestelling. Dit betekent dat bij gebreken of defecten
          aan het goed tot 2 jaar na de levering dit goed kosteloos wordt hersteld,
          dan wel vervangen. Voor zover dit mogelijk en redelijk is, hebt u de keuze
          tussen herstelling of vervanging. Enkel ingeval de herstelling of de
          vervanging buitensporig of onmogelijk is of niet binnen een redelijke
          termijn kan worden uitgevoerd, heeft u het recht om een prijsverlaging of de
          ontbinding van de verkoopsovereenkomst te eisen. Wij vragen u om ons
          eventuele gebreken of defecten te melden binnen de 2 maanden van de
          vaststelling ervan. Indien het defect of gebrek zich manifesteert binnen de
          6 maanden na de levering wordt dit geacht reeds te hebben bestaan voor de
          levering, tenzij wij het tegendeel kunnen bewijzen. Na 6 maanden zal u zelf
          moeten bewijzen dat het gebrek reeds bij de levering aanwezig was.
        </p>
        <h3><b>1.5 Staat van de goederen</b></h3>
        <p>
          Alle artikels die te koop aangeboden worden in de THE FASHION STORE e-shop
          zijn in nieuwstaat, ongedragen en onberispelijk schoon. Alle producten van
          de e-shop zijn geïllustreerd met foto's en voorzien van een duidelijke
          uitleg (merk, omschrijving, prijs, eventuele promoprijs, beschikbare maten,
          wasvoorschriften ... waar mogelijk). De afbeeldingen die we gebruiken zijn
          een waarheidsgetrouwe weergave van de aangeboden goederen. Indien we ons
          overduidelijk vergist hebben, zijn we niet verplicht je alsnog te leveren.
        </p>
        <h3><b>1.6 Waarheidsgetrouwe kleuren</b></h3>
        <p>
          We doen ons uiterste best om de kleuren van elk artikel waarheidsgetrouw
          weer te geven in de e shop. Hou er echter rekening mee dat de kleuren op de
          foto's licht kunnen afwijken van de echte kleuren (afhankelijk van o.a.
          beeldscherm, lichtsterkte ...). Aarzel niet om contact met ons op te nemen
          als je twijfelt over een kleur. <b>Contact: info@thefashionstore.be</b>
        </p>
        <h3><b>1.7 Aanbod van goederen en vrije keuze van bestelling</b></h3>
        <p>
          De presentatie van onze producten in de THE FASHION STORE e-shop is slechts
          een vrijblijvende uitnodiging om bij ons goederen te bestellen. Met het
          versturen van de bestelling ga je een bindende offerte aan voor het sluiten
          van een koopcontract.De offerte wordt door ons aanvaard doordat wij de
          goederen leveren. <br />
          De automatisch gegenereerde bevestigingsmail voor de bestelling is geen
          aanvaarding van de offerte, maar documenteert louter dat de bestelling bij
          ons is aangekomen. Het staat ons vrij om te beslissen of we een bestelling
          al dan niet aanvaarden. Als we een bestelling niet uitvoeren, delen we jou
          dit onmiddellijk mee. THE FASHION STORE verkoopt zijn artikels uitsluitend
          aan eindconsumenten met een leeftijd van 18 jaar en ouder, en alleen in
          hoeveelheden die in de handel gebruikelijk zijn. Als je geen 18 bent,
          verzoeken we om de bestelling door ouders of wettelijke voogd te laten
          plaatsen. Als we merken dat een bestelling is geplaatst door een
          minderjarige, kunnen we deze bestelling weigeren.
        </p>
        <h3><b>1.8 Beperking van aansprakelijkheid</b></h3>
        <p>
          De informatie op de website is van algemene aard. De informatie is niet
          aangepast aan persoonlijke of specifieke omstandigheden, en kan dus niet als
          een persoonlijk, professioneel of juridisch advies aan de gebruiker worden
          beschouwd. THE FASHION STORE levert grote inspanningen opdat de ter
          beschikking gestelde informatie volledig, juist, nauwkeurig en bijgewerkt
          zou zijn. Ondanks deze inspanningen kunnen onjuistheden zich voordoen in de
          ter beschikking gestelde informatie. Indien de verstrekte informatie
          onjuistheden zou bevatten of indien bepaalde informatie op of via de site
          onbeschikbaar zou zijn, zal THE FASHION STORE de grootst mogelijke
          inspanning leveren om dit zo snel mogelijk recht te zetten. THE FASHION
          STORE kan evenwel niet aansprakelijk worden gesteld voor rechtstreekse of
          onrechtstreekse schade die ontstaat uit het gebruik van de informatie op
          deze site.
        </p>
        <p>
          Indien u onjuistheden zou vaststellen in de informatie die via de site ter
          beschikking wordt gesteld, kan u de beheerder van de site contacteren. De
          inhoud van de site (links inbegrepen) kan te allen tijde zonder aankondiging
          of kennisgeving aangepast, gewijzigd of aangevuld worden. THE FASHION STORE
          geeft geen garanties voor de goede werking van de website en kan op geen
          enkele wijze aansprakelijk gehouden worden voor een slechte werking of
          tijdelijke (on)beschikbaarheid van de website of voor enige vorm van schade,
          rechtstreekse of onrechtstreekse, die zou voortvloeien uit de toegang tot of
          het gebruik van de website.
        </p>
        <p>
          THE FASHION STORE kan in geen geval tegenover wie dan ook, op directe of
          indirecte, bijzondere of andere wijze aansprakelijk worden gesteld voor
          schade te wijten aan het gebruik van deze site of van een andere,
          inzonderheid als gevolg van links of hyperlinks, met inbegrip, zonder
          beperking, van alle verliezen, werkonderbrekingen, beschadiging van
          programma's of andere gegevens op het computersysteem, van apparatuur,
          programmatuur of andere van de gebruiker. De website kan hyperlinks bevatten
          naar websites of pagina's van derden, of daar onrechtstreeks naar verwijzen.
          Het plaatsen van links naar deze websites of pagina's impliceert op geen
          enkele wijze een impliciete goedkeuring van de inhoud ervan. THE FASHION
          STORE verklaart uitdrukkelijk dat zij geen zeggenschap heeft over de inhoud
          of over andere kenmerken van deze websites en kan in geen geval
          aansprakelijk gehouden worden voor de inhoud of de kenmerken ervan of voor
          enige andere vorm van schade door het gebruik ervan.
        </p>
        <h2><b>2.Bestelling en betaling</b></h2>
        <h3><b>2.1 Bestelling en overeenkomst</b></h3>
        <p>
          Na registratie kan je via je shopping bag ("winkelmand" of "winkelwagen")
          een bestelling plaatsen in de e-shop. Binnen maximaal 2 uur krijg je een
          e-mail ter bevestiging van je bestelling met een samenvatting van je order.
          Na het betalen en ontvangen van je artikels heb je als klant 14 dagen de
          tijd om artikels te retourneren of om te ruilen, via de e-shop of de winkels
          (zie 'Verzakingsrecht'). Na het verstrijken van deze termijn is je aankoop
          definitief en blijf je eigenaar van de gekochte artikels. We raden je aan
          voorafgaand contact met ons op te nemen in geval van vragen of twijfels om
          misverstanden en teleurstellingen te voorkomen. We gaan ervan uit dat je
          jouw gegevens naar waarheid doorgeeft bij het registreren en het plaatsen
          van een bestelling. Foutieve of onvolledige informatie kan immers een vlotte
          orderverwerking en levering in het gedrang brengen. Daarnaast is het ook de
          verantwoordelijkheid van jou als klant om je wachtwoord vertrouwelijk te
          houden om misbruik te voorkomen.
        </p>
        <h3><b>2.2 Minimale bestelwaarde</b></h3>
        <p>De minimale bestelwaarde in de e-shop is 19,95 euro incl. btw.</p>
        <h3><b>2.3 Betaalmogelijkheden</b></h3>
        <p>
          De e-shop voorziet verschillende betaalmogelijkheden van bestellingen in de
          e shop. Betaal je via online banking (BNP Paribas Fortis, Dexia, ING en KBC)
          of creditcard (VISA en Mastercard), dan wordt het bedrag meteen van je
          rekening afgehouden en kunnen we je bestelling onmiddellijk verwerken.
          Indien de uitgever van je kaart weigert om in te stemmen met je betaling aan
          ons, kunnen wij niet verantwoordelijk worden gesteld voor vertragingen bij
          de levering en/of niet-levering van uw bestelling.
        </p>
        <h3><b>2.4 Veilig online betalen</b></h3>
        <p>
          Online betalen in de e-shop gebeurt door middel van een beveiligde
          transactie in samenwerking met onze partner Adyen. Je betaalgegevens en
          creditcardinfo worden enkel gebruikt voor de betaling en nooit vrijgegeven
          aan andere partijen.
        </p>
        <h3><b>2.5 prijsaanduiding</b></h3>
        <p>
          THE FASHION STORE engageert zich om in de e-shop te allen tijde correcte
          prijzen weer te geven voor de te koop aangeboden artikelen. In het
          uitzonderlijke geval dat er abusievelijk niet-correcte prijzen worden
          geafficheerd, hetzij als gevolg van een technisch probleem hetzij door een
          menselijke fout, geldt steeds het zogenaamde 'criterium van de goede trouw
          van de consument'. De verplichting van de verkoper om te verkopen tegen de
          prijs die in de rekken of op zijn website staat aangeduid, zelfs als die
          fout is in zijn nadeel, wordt afgezwakt door het criterium van de goede
          trouw van de consument, die redelijkerwijs moet hebben kunnen geloven dat de
          aangeduide prijs correct was.” (bron: OIVO, het Onderzoeks- en
          Informatiecentrum van de Verbruikersorganisaties, verwijzend naar de
          wetgeving i.v.m. redelijkheid in prijsaanduiding)
        </p>
        <h2><b>3.Levering</b></h2>
        <h3><b>3.1 Leveringsmogelijkheden</b></h3>
        <p>
          De e-shop voorziet verschillende leveringsmogelijkheden van bestellingen in
          de e-shop. Tijdens de bestelprocedure heb je de keuze: ofwel haal je je
          bestelling gratis zelf af in een THE FASHION STORE-winkel naar keuze, ofwel
          kies je voor levering van je artikels op een bestaand adres via Bpost. THE
          FASHION STORE is niet verantwoordelijk voor eventuele douanekosten en
          mogelijk bijkomende taksen, belastingen of heffingen die na de verzending
          door derden worden toegepast.
        </p>
        <h3><b>3.2 Modaliteiten verzending naar postadres</b></h3>
        <p>
          Alle pakjes van de THE FASHION STORE e-shop worden verzonden door onze
          partner Bpost. Een bestelling wordt uiterlijk binnen 5 werkdagen na de
          besteldatum verzonden. Voor het merendeel van de artikels geldt 'op een
          werkdag besteld voor 19 uur, volgende dag geleverd.' De leveringstermijn
          wordt meegedeeld onderaan in de winkelwagen. Als je niet aanwezig bent op
          het ogenblik dat de Bpost-leverancier je pakje aanbiedt, wordt jouw pakje
          standaard aan de buren gegeven en wordt er hiervan een bericht achtergelaten
          in je brievenbus. Indien je dit liever niet wilt, of je andere aanwijzingen
          hebt voor de levering, kan je deze doorgeven via de website van Bpost.
        </p>
        <h3><b>3.3 Levering in een THE FASHION STORE-winkel</b></h3>
        <p>
          Je kan ervoor kiezen je pakje af te halen in een THE FASHION STORE-winkel
          naar keuze. Deze leveringsmethode is gratis. Onze winkels bewaren een pakje
          van de e-shop 14 dagen. Als je na 14 dagen je pakje niet bent komen afhalen,
          worden de artikels naar THE FASHION STORE teruggestuurd. Daar bewaren we je
          artikels zorgvuldig tot je contact met ons opneemt, online of telefonisch op
          het nummer 02/568.11.85. We leveren je artikels opnieuw af in een THE
          FASHION STORE-winkel of versturen ze voor 4,95 euro via bpost naar een
          Belgisch postadres van jouw keuze.
        </p>
        <h3><b>3.4 Voorraden</b></h3>
        <p>
          We doen er alles aan om de voorraad van de artikelen in de e-shop correct
          weer te geven. Indien ondanks onze inspanningen een artikel na bestelling
          toch niet voorradig zou blijken te zijn, informeren we jou als klant daar
          meteen over. We storten het bedrag van de niet-voorradige artikels terug op
          jouw rekening en bezorgen je een aangepaste factuur. THE FASHION STORE kan
          in geen geval aansprakelijk gehouden worden in geval van niet-levering van
          bestelde artikelen wegens stockbreuk of ontbrekende voorraad.
        </p>
        <h2><b>4.Gratis retour</b></h2>
        <h3><b>4.1 Verzakingsrecht</b></h3>
        <p>
          Je hebt als klant het recht om af te zien van je verkoop, zonder betaling
          van een boete en zonder opgave van motief, binnen 14 dagen vanaf de dag die
          volgt op de levering van je artikels. Om gebruik te maken van je
          verzakingsrecht, breng je THE FASHION STORE hiervan schriftelijk of via
          e-mail op de hoogte. Hiervoor kan je het modelformulier uit Boek VI van het
          Belgisch Wetboek Economisch Recht gebruiken. Na ontvangst van het
          retourpakket, betalen we je het totaalbedrag van de retourartikels terug.
          Opgelet: retourartikels dienen te voldoen aan bepaalde voorwaarden om in
          aanmerking te komen voor terugbetaling (zie 'Retourvoorwaarden'). Let op:
          geen retour of omruilen mogelijk voor nagellak, parfum, cosmetica en
          panini-artikelen.
        </p>
        <h3><b>4.2 Retourprocedure</b></h3>
        <p>
          Artikels omruilen is bij THE FASHION STORE geen probleem. Dit kan na
          ontvangst van je bestelling in elke THE FASHION STORE-winkel. Je kan je
          artikel in de THE FASHION STORE-winkel ook omruilen voor een terugbetaling
          of terugsturen met Bpost om jouw terugbetaling te ontvangen. Retourartikels
          stuur je bij voorkeur in de originele verpakking terug. Gebruik voor een
          retourzending altijd de adressticker ('retourzending') die in elk pakje
          meegeleverd wordt. Gelieve steeds duidelijk de reden van retourzending in te
          vullen. Retour kan via verzending door Bpost of via afgifte in een THE
          FASHION STORE-winkel naar keuze. In beide gevallen dient de retoursticker op
          de originele verpakking gekleefd te worden.
        </p>
        <h6>
          * retour en omruilen per Bpost: enkel gratis binnen België via een Bpost
          parcel shop
        </h6>
        <h3><b>4.3 Retourvoorwaarden</b></h3>
        <p>
          Vul het retourformulier in en stop het samen met de artikels die je wil
          omruilen in de originele verpakking. Kleef de retoursticker die je in je
          pakje vond over de oude adressticker en geef je pakje binnen 14 dagen af in
          een Bpost parcel shop of in een THE FASHION STORE-store naar keuze.
          Retourartikels zijn echter gevoelige wezentjes. Hou daarom aub rekening met
          het volgende:
        </p>
        <ul>
          <li>
            • Retourartikels hebben heimwee - Zorg ervoor dat je ze binnen 14 dagen
            terugzendt per Bpost of afgeeft in een THE FASHION STORE store.
          </li>
          <li>
            • Retourartikels hebben stijl - Ze zijn altijd ongedragen en onberispelijk
            schoon. Ze mogen gepast zijn, maar niet gebruikt.
          </li>
          <li>
            • Retourartikels zijn old school - Ze gaan nooit de deur uit zonder hun
            originele labels.
          </li>
          <li>
            • Retourartikels zijn gewoontedieren - Ze reizen bij voorkeur in hun
            originele verpakking.
          </li>
        </ul>
        <p>
          Tijdens de eerste 14 dagen na de levering verwachten we dat je zorgvuldig
          omgaat met de bestelling en de verpakking. Als je de goederen nog wil
          terugsturen zoals hierboven omschreven, mag je ze enkel in die mate
          uitpakken of gebruiken als nodig is om te kunnen beoordelen of je het goed
          wenst te behouden. Teruggestuurde goederen mogen gepast zijn, maar mogen
          niet gebruikt zijn. Als je de goederen terugstuurt, doe dit dan bij voorkeur
          samen in de originele verpakking, met alle geleverde toebehoren en in de
          originele staat en verpakking en rekening houdende met onze instructies
          hierboven.
        </p>
        <p>
          Als je alle voorwaarden respecteert, zorgen we binnen 14 dagen na ontvangst
          van de retourartikelen voor een gegarandeerde terugbetaling van het
          totaalbedrag van de retourartikelen.
        </p>
        <p>
          Let op: geen retour of omruilen mogelijk voor nagellak, parfum, cosmetica en
          panini-artikelen.
        </p>
        <h3><b>4.4 Beschadigde artikels en fabricagefouten</b></h3>
        <p>
          We verpakken en verzenden onze artikels altijd met de grootste zorg. Op die
          manier wordt de kans op schade tijdens de verzending tot het minimum
          herleid. Alle artikels worden voor verzending ook zorgvuldig gecontroleerd
          op eventuele fabricagefouten.<br />
          Indien de door ons geleverde goederen tijdens het transport werden
          beschadigd, niet overeenstemmen met de artikelen die op de leveringsbon
          vermeld staan of niet overeenkomen met de artikelen die je had besteld, moet
          je dit zo snel mogelijk melden en de artikelen naar ons terug sturen binnen
          de 14 kalenderdagen na ontvangst.<br />
          We kunnen niet verantwoordelijk worden gesteld voor enige gevolgschade
          wegens laattijdige levering of niet-levering door de transporteur die de
          onderneming heeft aangesteld. Onze aansprakelijkheid blijft in dergelijke
          gevallen beperkt tot de waarde van de artikelen waarvan wordt aangetoond dat
          ze niet door de klant werden ontvangen.
        </p>
        <h2><b>5.Klantenreacties en aanvullende ondersteuning</b></h2>
        <p>
          Indien je de bovenstaande informatie niet begrijpt of als je opmerkingen of
          suggesties hebt over een bestelling of over de e-shop in het algemeen, dan
          horen wij dat graag van jou. Neem gerust contact met ons op. Dat kan via
          het <u>online contactformulier,</u> de online customer service chat of
          telefonisch op het nummer 02 568 11 85.
        </p>
        <p>
          Bij vragen, opmerkingen of klachten kan je in de eerste plaats terecht bij
          onze Customer Service. We helpen je met plezier verder, binnen de werkdag
          mag je van ons een persoonlijk antwoord verwachten.
        </p>
        <p>
          Als drager van de kwaliteitslabels BeCommerce en Safeshops informeren we je
          bovendien met plezier over 
          de <u>
            BeCommerce procedure bij vragen &amp; klachten en het Safeshops
            klachtenformulier,
          </u> via
          info@SafeShops.be of schriftelijk: Kapelsesteenweg 195/1, 2180 Ekeren.
        </p>
        <p>
          Naast onze eigen klachtenprocedure, kan u sinds 1 juni 2015 voor
          buitengerechtelijke consumentengeschillen terecht bij de
          Consumentenombudsdienst (COD). Deze dienst kan u in de eerste plaats
          informatie verschaffen over uw rechten als consument. Indien u klachten
          heeft, kan u hiervoor ook bij de COD terecht. De COD zal uw klacht
          analyseren om deze vervolgens aan het bevoegde bemiddelingsorgaan door te
          geven.
        </p>
        <p>Meer info op https://www.consumentenombudsdienst.be/nl</p>
        <p>
          Tot slot kan je ook terecht bij bij het Online Dispute Resolution platform
          van de EU, op
          https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&amp;lng=EN
        </p>
        <h2><b>6.Copyright</b></h2>
        <p>
          De inhoud van de website www.thefashionstore.be is eigendom van The Fashion
          Society NV. Hieronder wordt verstaan: teksten, grafieken, foto's,
          afbeeldingen, bewegende beelden, geluiden, illustraties en software. Deze
          inhoud is auteursrechtelijk of door andere rechten beschermd. Het is
          verboden om deze inhoud zonder schriftelijke toestemming van THE FASHION
          STORE over te nemen, te publiceren, te verveelvoudigen of op enige andere
          wijze te gebruiken. In geval van overtreding zullen we niet aarzelen
          juridische stappen te ondernemen.
        </p>
      </div>
    </div>
  );
}

export default widget_user_agreement;



// WEBPACK FOOTER //
// ./src/plugins/tfs/platformConfigs/widgets/widget_user_agreement/index.js